import { useQuery } from "@tanstack/react-query";
import { Product } from "resbutler-utils/types/product";
import { getConfigUI } from "../init";
import { fetchStorageJson } from "./storageJson";

const DEFAULT_PRODUCTS: Product[] = [];

const useProductsStorage = (useCacheBuster = true) => {
  async function loadProducts() {
    const { client, config } = getConfigUI();
    return fetchStorageJson<Product[]>(`https://storage.googleapis.com/${config.publicStorageBucket}/${client}/productData/products.json`, useCacheBuster);
  }

  const { isLoading, data: products = DEFAULT_PRODUCTS } = useQuery<Product[]>({
    queryKey: ["products"],
    enabled: true,
    queryFn: () => loadProducts(),
    staleTime: 30 * 60 * 1000, // 30 minutes
    gcTime: 60 * 60 * 1000, // 60 minutes
  });

  return [isLoading, products] as [boolean, Product[]];
};

export default useProductsStorage;
